import PropTypes from 'prop-types';
import { useId } from '../../hooks/use-id.js';
import { createComponent } from '../core/create-component.js';
import 'react';
import 'tiny-warning';
import { useFormFieldProps } from '../form/form.context.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
const propTypes = {
  skin: PropTypes.oneOf(['standard', 'error']),
  resize: PropTypes.oneOf(['both', 'vertical']),
  fullWidth: PropTypes.bool
};
const TextArea = createComponent({
  displayName: 'TextArea',
  root: 'textarea',
  propTypes,
  propConfig: {
    processProps(props) {
      const formProps = useFormFieldProps(useId(props.id));
      return _objectSpread({}, props, formProps);
    },
    classNames(props) {
      const classNameSet = new Set(['swan-textarea']);
      const {
        skin = 'standard',
        resize = 'both',
        'aria-invalid': ariaInvalid,
        fullWidth = false
      } = props;
      if (skin === 'error' || ariaInvalid) classNameSet.add("swan-textarea-skin-error");
      if (fullWidth) classNameSet.add("swan-textarea-full-width");
      if (resize === 'vertical') classNameSet.add("swan-textarea-resize-vertical");
      return classNameSet;
    }
  }
});
export { TextArea };